<template>
  <div class="yx-personal-info-page div-scroll">
    <el-card shadow="never">
      <el-row class="add-form">
        <el-form
          size="small"
          :model="handleData"
          ref="cForm"
          :rules="formRules"
          :label-width="'150px'"
        >
          <el-col :span="24" class="sub-title">基本信息</el-col>
          <el-col :span="16">
            <c-form-item :formItems="formItemsBasic1" ref="cFormItem1" />
          </el-col>
          <!-- <el-col :span="8">
            <div class="upload-box">
              <h4>照片：</h4>
              <el-upload
                class="avatar-uploader"
                :action="action"
                :limit="1"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleAvatarRemove"
              >
                <img
                  v-if="handleData.img"
                  :src="handleData.img"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-col> -->
          <el-col :span="16">
            <c-form-item :formItems="formItemsBasic2" ref="cFormItem2" />
          </el-col>
          <!-- <el-col :span="24" v-show="handleData.isLoan == 1">
            <c-form-item :formItems="formItemsBasic4" ref="cFormItem2" />
          </el-col> -->
          <el-col :span="24" class="sub-title">学籍信息</el-col>
          <el-col :span="24">
            <c-form-item :formItems="formItemsBasic3" ref="cFormItem2" />
          </el-col>

          <el-col :span="24" style="text-align: center">
            <el-form-item label-width="0">
              <slot name="other">
                <el-button type="primary" @click="submit" size="medium" :disabled="isSubmit"
                  >提交</el-button
                >
              </slot>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import Configs from "./data/newsRequired.js";
import MHandle from "@/mixins/MHandle.js";
let mHandle = MHandle({
  handleGetPathNoparam: "/account/base/student/myInfo",
  handleInsertPath: "/account/base/student/save",
  handleUpdatePath: "/account/base/student/update",
  handleDownLoadPath: "",
  handleData: {
    img: "",
  },
});
export default {
  mixins: [mHandle],
  provide() {
    return {
      cForm: this,
    };
  },
  props: {
    id: String,
  },
  data() {
    let {
      formItemsBasic1,
      formItemsBasic2,
      formItemsBasic3,
      formItemsBasic4,
      formRules,
    } = Configs(this);
    return {
      formItemsBasic1,
      formItemsBasic2,
      formItemsBasic3,
      formItemsBasic4,
      formRules,
      value: {},
      action: "http://61.184.241.22:8088/zlf/upload?prefix=appointment",
      studentId: "",
      isSubmit:false, // 是否提交中
    };
  },
  watch: {
    handleData: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.studentId = this.id;
  },
  mounted() {
    this.handleGetNoparam();
  },
  methods: {
    handleGetAfterFn(data){
      if(!data) return {}
    },
    submit() {
      this.$refs.cForm.validate((valid) => {
        if (valid) {
          this.$confirm("确定修改保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.isSubmit = true;
              if (this.handleData.id) {
                this.handleUpdate();
              } else {
                this.handleInsert();
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
    },
    handleAvatarRemove() {
      this.handleData.img = null;
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.handleData.img = res.fileUrl;
      console.log(this.handleData.img);
    },
    handleAfterFn() {
      this.isSubmit = false;
    },
    handleBeforeFn() {
      if (this.handleData.isLoan == 0) {
        this.handleData.loanAmount = 0;
      }
    },
  },
};
</script>

